import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b81e4da&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=6b81e4da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81e4da",
  null
  
)

export default component.exports